import {
  getAll,
  getPage,
  getDetail,
  analyzeNotOnline,
  analyzeSingle,
} from '@/api/gdczzdsjjrptdataserv'

export default {
  state: {
    state_GdczzdsjjrptData_GetAllResult: null,
    state_GdczzdsjjrptData_GetPageResult: null,
    state_GdczzdsjjrptData_GetDetailResult: null,
    state_GdczzdsjjrptData_AnalyzeNotOnlineResult: null,
    state_GdczzdsjjrptData_AnalyzeSingleResult: null,
  },
  mutations: {
    SET_GDCZZDSJJRPTDATA_GETALL_RESULT: (state, rst) => {
      state.state_GdczzdsjjrptData_GetAllResult = rst;
    },
    SET_GDCZZDSJJRPTDATA_GETPAGE_RESULT: (state, rst) => {
      state.state_GdczzdsjjrptData_GetPageResult = rst;
    },
    SET_GDCZZDSJJRPTDATA_GETDETAIL_RESULT: (state, rst) => {
      state.state_GdczzdsjjrptData_GetDetailResult = rst;
    },
    SET_GDCZZDSJJRPTDATA_ANALYZENOTONLINE_RESULT: (state, rst) => {
      state.state_GdczzdsjjrptData_AnalyzeNotOnlineResult = rst;
    },
    SET_GDCZZDSJJRPTDATA_ANALYZESINGLE_RESULT: (state, rst) => {
      state.state_GdczzdsjjrptData_AnalyzeSingleResult = rst;
    },
  },
  actions: {
    GdczzdsjjrptDataServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDCZZDSJJRPTDATA_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDCZZDSJJRPTDATA_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdczzdsjjrptDataServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDCZZDSJJRPTDATA_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDCZZDSJJRPTDATA_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdczzdsjjrptDataServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDCZZDSJJRPTDATA_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDCZZDSJJRPTDATA_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdczzdsjjrptDataServ_AnalyzeNotOnline({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        analyzeNotOnline(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDCZZDSJJRPTDATA_ANALYZENOTONLINE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDCZZDSJJRPTDATA_ANALYZENOTONLINE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdczzdsjjrptDataServ_AnalyzeSingle({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        analyzeSingle(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDCZZDSJJRPTDATA_ANALYZESINGLE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDCZZDSJJRPTDATA_ANALYZESINGLE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdczzdsjjrptData_GetAllResult: state => {
      return state.state_GdczzdsjjrptData_GetAllResult;
    },
    get_GdczzdsjjrptData_GetPageResult: state => {
      return state.state_GdczzdsjjrptData_GetPageResult;
    },
    get_GdczzdsjjrptData_GetDetailResult: state => {
      return state.state_GdczzdsjjrptData_GetDetailResult;
    },
    get_GdczzdsjjrptData_AnalyzeNotOnlineResult: state => {
      return state.state_GdczzdsjjrptData_AnalyzeNotOnlineResult;
    },
    get_GdczzdsjjrptData_AnalyzeSingleResult: state => {
      return state.state_GdczzdsjjrptData_AnalyzeSingleResult;
    },
  }
}